import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import { GetAccountError, GetAccountVariables, fetchGetAccount } from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getAccount;

export function useGetAccount(
  variables: GetAccountVariables,
  opts?: UseQueryOptions<Response, GetAccountError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetAccountError>(
    queryKeyFn({
      path: '/api/v1/account',
      operationId: 'getAccount',
      variables,
    }),
    async () => {
      const res = await fetchGetAccount({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
